import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DonorsDto } from './donor.dto';


export class DonorsResponseModel extends GlobalResponseObject{
    data?: DonorsDto;

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: DonorsDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
